/* import __COLOCATED_TEMPLATE__ from './visualization-container.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();